import { Moment } from "moment";
import Utils from "../../core/shared/utils";
import { SyncModel, SyncDataModel, DataModel } from "../../core/shared/models/syncModel";
import { ContentType, ImageOrientation } from "../../core/shared/contentTypes";

// ViewModel
export class SOTStartpageViewModel {
  public get sort_no(): number {
    return this._model.sort_no;
  }
  public get media_is_video(): boolean {
    return this._model.media_is_video;
  }

  public get has_media(): boolean {
    return this._model.last_media_update_at_ymd > 0;
  }
  public get media_path(): string {
    if (this.has_media)
      return ContentType.SOTStartpage + "/" + this._model.id + "_media_" + ImageOrientation.Portrait + "/" + this._model.last_media_update_at_ymd + "/" + this._model.last_media_update_at_hms;
    else
      return "";
  }

  private _model : SOTStartpageDataModel;
  public get model() : SOTStartpageDataModel {
    return this._model;
  }

  constructor(model: SOTStartpageDataModel) {
    const me = this;
    me._model = model;
  }
}

// Requests
export class SOTStartpageSyncModel extends SyncModel {
  public hyp_cus_nr: number;
}

// Responses
export class SOTStartpageDataModel extends DataModel {
  public get DM_Key(): number | string { return this.id; }
  public id: number;
  public label: string;
  public active: boolean;
  public sort_no: number;
  public media_is_video: boolean;
  public last_media_update_at_ymd: number;
  public last_media_update_at_hms: number;
  public get last_media_update_at(): Moment {
    return Utils.GetMomentFromInt(this.last_media_update_at_ymd, this.last_media_update_at_hms);
  }
  public deleted: boolean;
  public change_at_ymd: number;
  public change_at_hms: number;
  public get change_at(): Moment {
    return Utils.GetMomentFromInt(this.change_at_ymd, this.change_at_hms);
  }
}

export class SOTStartpageSyncDataModel extends SyncDataModel {
  public startpages: SOTStartpageDataModel[];
  public get models(): DataModel[] { return this.startpages; }
  public DeserializeType(): void {
    this._DeserializeType(SOTStartpageDataModel);
  }
}
